<template>
<div>
    <div class="number-container">
    <div class="sub no-select" @click="sub">
      <img :src="require('@/assets/images/dis1.png')" alt="">
    </div>
    <input  type="number" v-model="number" @keydown="input" @blur="blur" />
    <div class="add no-select" @click="add">
      <img :src="require('@/assets/images/add1.png')" alt="">
    </div>
  </div>
 <err v-if="errorShow">商品数量不足 </err>
</div>

</template>

<script>
import err from './error'
export default {
  components:{err},
  data() {
    return {
      number: 1,
      errorShow:false,
    };
  },
  props: {
    maxNumber:{
      type:Number,
      default:999
    },
    num:{
      type:Number,
     // default:1
    },
    skuNum:{
      // type:Number,
     // default:1
    }
  },
  watch:{
    num: {
      handler: function(t, f) {
					if (this.skuNum) {

						if (this.num < this.skuNum) {
							this.number = this.skuNum
						} else {
              this.number = t;
              this.zhxsCount()
              this.$emit("eventClick", this.number);
              
							// uni.$emit('updateCartGoodsNum')
						}
					} else {
						this.number = t
					}
					// this.$emit("eventClick", t);
				},
				immediate: true,
			}

  },
  mounted(){

  },
  created(){

  this.$nextTick(()=>{
      if(this.num){
     this.number = this.num
    } else if(this.skuNum){
     this.number = this.skuNum
   }else{
     this.number = 1
   }

  })
  
  
  },
 
  methods: {
    	blur() {
				// 刚失去焦点时，保存数据矫正前数量 防止立即触发数量叠加
				this.isBlur = true;
				this.isBlurNum = this.number
				if(this.skuNum){
					
				//	console.log('isBlurNum===================',this.isBlurNum)
					this.zhxsCount() //数据矫正
			//		console.log('blurAfterNum===================',this.number)
					// 失去焦点一段时间后false，数量可正常加减
					
				}else{
					this.number = this.number?this.number:1
				}
				setTimeout(()=>{
					this.isBlur = false
        },300)
         this.$emit("eventClick", this.number);
        
			},
    	input(e) {
				setTimeout(() => {
					this.number = Math.ceil(this.number)
					
					this.number<=0?this.number='':null;
					this.number>this.maxNumber?this.number = this.maxNumber:null;
					
				});
			},
			sub() {
				if(this.skuNum){
					this.number>this.skuNum?(this.number = this.number - this.skuNum):null
					// 回减需要立马触发，否则 在失去焦点时数量被矫正是向上取整
					this.isBlur = false
				}else{
					this.number>1?this.number--:null;
        }
         this.$emit("eventClick", this.number);
			},

			add() {
				if(this.skuNum){
					// 刚失去焦点时，数据矫正 防止立即触发数量叠加，如果修改的数量和矫正的一样，则可以增加
					if(this.isBlur&&this.isBlurNum!=this.number){
						this.isBlur = false
					}else{
						this.number<this.maxNumber?(this.number = this.number + this.skuNum):null
					}
				}else{
					if(this.isBlur&&this.isBlurNum!=this.number){
						this.isBlur = false
					}else{
						this.number<this.maxNumber?this.number++:null;
					}
				}
         this.$emit("eventClick", this.number);
			},
			// 整合销售数量矫正
			zhxsCount() {
				// if (this.number >= this.maxNumber) {
				// 	let num = this.maxNumber - (this.maxNumber % this.skuNum)
				// 	this.number = num
				// 	return
				// }
				if (this.number % this.skuNum == 0 && this.number == 0) {
					this.number = this.skuNum;
				}  else if (this.number % this.skuNum != 0 && this.number > 0) {
					let num = this.skuNum + this.number - this.number % this.skuNum;
					this.number = num;
				}
			},
    error(){
       this.errorShow = false
    }

  },
};
</script>
<style lang="scss" scoped>
.number-container {
  height: 32px;
  width: 112px;
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  .sub,
  .add {
    width: 36px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img{
      width: 13px;
      height: 13px;
      // @include size(100%,100%)

    }
  }
// .sub{
//   background: url('../assets/images/dis1.png') no-repeat;
//   background-size: 10px;
//   background-position: center;
// }
// .add{
//   background: url('../assets/images/add1.png') no-repeat;
//   background-size: 10px;
//   background-position: center;

// }
  input {
    width: 40px;
    text-align: center;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/input-number.vue